module.exports = __webpack_public_path__ + "img/product.a3ff14a8.png";